import Vue from 'vue'
import VueRouter from 'vue-router'
import { publicRoutes, notFoundRoute } from './routes/constant'
import { asyncRoutes } from './routes/async'
import { setupRouterGuard } from './guard'

// 解决重复导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

// 合并所有路由
const routes = [...publicRoutes, ...asyncRoutes, notFoundRoute]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ y: 0 }), // 路由切换时滚动到顶部
})

// 配置路由守卫
setupRouterGuard(router)

export default router
